import { lazy } from "react";
import Loadable from "app/components/Loadable";

const WhatsAppOnboardingPage = Loadable(lazy(() => import("./WhatsAppOnboardingPage")));

const WhatsAppOnboardingRoutes = [
  {
    path: "/admin/whatsapp-onboarding",
    element: <WhatsAppOnboardingPage />,
  },
];

export default WhatsAppOnboardingRoutes;
